import queryClient from "../queries/queryClient";

const invalidateDashboardCache = () => {
  queryClient.invalidateQueries(["dashboard", "summary"]);
};

export default invalidateDashboardCache;
